import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { Label } from "@fluentui/react/lib/Label";
import { Stack } from "@fluentui/react/lib/Stack";
import { TextField } from "@fluentui/react/lib/TextField";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { syncStart } from "Store/Actions";
import { isNullOrWhiteSpace } from "Utils/String";
import { ISyncProps } from "./ISyncProps";
import { Months } from "./Months";
import { useSyncStyles } from "./UseSyncStyles";
import { Provider } from "./Provider";

export const Sync = WithTheme(
  WithTranslator((props: ISyncProps): JSX.Element => {
    const {
      translator,
      theme: { spacing }
    } = props;
    const styles = useSyncStyles();
    const dispatch = useDispatch();
    const [id, setId] = useState(``);
    const [userName, setUserName] = useState(``);

    const [months, setMonths] = useState(6);
    const onMonthsChange = useCallback((newMonths: number) => setMonths(newMonths), []);

    const disabledSyncButton = isNullOrWhiteSpace(id) || isNullOrWhiteSpace(userName);

    const onIdChange = useCallback((newId?: string) => setId(newId), []);
    const onUserNameChange = useCallback((_, newUserName?: string) => setUserName(newUserName), []);

    const onClick = useCallback(() => {
      dispatch(syncStart(id, userName, months));
    }, [dispatch, id, months, userName]);

    return (
      <Stack className={styles.root}>
        <Stack.Item>
          <Label>{translator.get(`settings.sync.label`, `Manual project synchronization`)}</Label>
        </Stack.Item>
        <Stack horizontal tokens={{ childrenGap: spacing.s2 }}>
          <Provider onChange={onIdChange} className={styles.code} />
          <TextField
            className={styles.user}
            placeholder={translator.get(`settings.sync.provideruser`, `Username`)}
            onChange={onUserNameChange}
          />
          <Months onChange={onMonthsChange} className={styles.months} />
          <PrimaryButton
            className={styles.button}
            disabled={disabledSyncButton}
            iconProps={{ iconName: `Sync` }}
            onClick={onClick}
          />
        </Stack>
      </Stack>
    );
  })
);
